import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ChevronDownSVG from 'src/assets/svg/chevronDown.svg';
import { appUtils, Base } from 'src/components';
import EditGoal from 'src/pagesDashboard/GoalSettings/EditGoal';
import NewGoal from 'src/pagesDashboard/GoalSettings/NewGoal';
import ViewGoal from 'src/pagesDashboard/GoalSettings/ViewGoal';
import HeaderV2 from 'src/containers/Header/HeaderV2';
import STYLE from 'src/constants/style';

const mobileSize = appUtils.getMobileSize();
const isMobile = mobileSize;

const GoalSettings = ({ mode, parentProps }) => {
  const navigate = useNavigate();
  const { goalId, userId } = useParams();
  const [searchParams] = useSearchParams();
  const parentId = searchParams.get('parentId');
  const redir = searchParams.get('redir');

  return (
    <>
      <HeaderV2
        overtitle='Tracking'
        title='Goals'
        absoluteIcon
        onClickIcon={() => {
          if (redir) {
            navigate(redir);
          } else {
            window.history.back();
          }
        }}
        icon={(
          <ChevronDownSVG
            width={27}
            height={27}
            transform='rotate(270)'
            stroke='black'
          />
        )}
      />
      <Base classes={isMobile ? '' : STYLE.BASE}>
        {mode === 'view' ? (
          <ViewGoal
            goalId={goalId}
            userId={userId}
            parentId={parentId}
            {...parentProps}
          />
        ) : null}
        {mode === 'edit' ? (
          <EditGoal
            goalId={goalId}
            userId={userId}
            parentId={parentId}
            {...parentProps}
          />
        ) : null}
        {mode === 'new' ? (
          <NewGoal
            goalId={goalId}
            userId={userId}
            parentId={parentId}
            {...parentProps}
          />
        ) : null}
      </Base>
    </>
  );
};

export default GoalSettings;
